var exports = {
  "CustomerStories": "CustomerStories__xWvvf5",
  "CustomerStories__gridContent": "CustomerStories__gridContent__ilCiSm",
  "CustomerStories__dividerColumn": "CustomerStories__dividerColumn__bwdT7t",
  "CustomerStories__divider": "CustomerStories__divider__L-xWwU",
  "CustomerStories__column": "CustomerStories__column__5ciDTE",
};

__webpack_require__.r(module.exports = exports);
